import type { Translations } from '../en/index.js';

/** Copy taken from the Arabic side of the design, which was written natively. */
export const ar: Translations = {
  common: {
    nav: {
      work: 'أعمالي',
      approach: 'منهجي',
      about: 'عني',
      hire: 'اعمل معي',
      menu: 'القائمة',
    },
    localeLabel: 'اللغة',
    skipToContent: 'انتقل إلى المحتوى',
    portraitAlt: 'أحمد المصري',
    footer: {
      rights: '© 2026 أحمد المصري · أيندهوفن، هولندا',
      photography: 'الصور بعدسة {{photographer}}',
      privacy:
        'يُحصي هذا الموقع الزيارات بتحليلات مستضافة ذاتياً. بلا كوكيز، وبلا تتبّع عبر الأيام، ولا شيء يُعرّف بك.',
    },
    mobileBar: {
      status: 'متاح لأدوار القيادة والاستشارات',
      cta: 'اعمل معي',
    },
  },

  hero: {
    availability: 'أيندهوفن · متاح لأدوار القيادة والاستشارات',
    nameLine1: 'أحمد',
    nameLine2: 'المصري',
    lede: 'عشر سنوات أُحوّل فيها بيانات الآلات الفوضوية إلى أنظمة يثق بها الناس.',
  },

  stats: {
    throughput: 'رسالة في الثانية عبر وسيط أعدتُ بناءه',
    database: 'أسرع في قاعدة البيانات، بالعتاد نفسه',
    deploy: 'للنشر، بعد أن كان يستغرق يوماً كاملاً',
    engineers: 'مهندساً قدتهم عبر ثلاثة منتجات',
  },

  work: {
    titleLine1: 'مختارات',
    titleLine2: 'من أعمالي',
    lede: 'ثلاثة أنظمة، كلٌّ منها كان مشكلة حِمل… ثم لم يعد.',
    cases: {
      'sg-wireless': {
        title: 'مليون رسالة في الثانية، وما زال هناك متّسع',
        body: 'كان الوسيط يصل إلى حدّه قبل أن يصل أسطول الأجهزة إلى حدّه. جعلتُ الوسيط والوكيل بلا حالة ليتوسّعا عند الطلب، وفصلتُ حركة الإدخال عن حركة الاستعلام، وأعدتُ الفهرسة وفق الطريقة التي تُقرأ بها البيانات فعلاً.',
      },
      withthegrid: {
        title: 'معرفة أي أصل في الشبكة سيتعطّل تالياً',
        body: 'قدتُ منصّة مراقبة الأصول والفريق الذي يقف خلفها — أُترجم نيّة المنتج إلى بنية تصمد مع تزايد عدد الأصول.',
        outcome: 'توسّعت دون إعادة كتابة.',
      },
      pycom: {
        title: 'عشرون مهندساً، ثلاث خرائط طريق، خطّ إنتاج واحد',
        body: 'التحقتُ مهندساً وغادرتُ وأنا أقود المجموعة. شحنّا في موعدنا لأننا أتمتنا الأجزاء المملّة — نزل النشر من يوم كامل إلى أقل من ساعة.',
        outcome: 'ثلاث خرائط طريق، كلّها في موعدها.',
      },
    },
  },

  approach: {
    title: 'كيف أعمل',
    lede: 'أربع عادات تصمد أمام موعد تسليم حقيقي.',
    habits: {
      measure: {
        title: 'قِس قبل أن تتحرّك',
        body: 'ابحث عن عنق الزجاجة الحقيقي قبل أن تمسّ البنية. نصف حالات «نحتاج إعادة كتابة» تتحوّل إلى فهرس ناقص.',
      },
      boring: {
        title: 'مملٌّ حيث يجب',
        body: 'أدوات مُجرَّبة في المسار الحرج. واترك التجريب للمواضع التي يكون فيها الفشل رخيصاً وقابلاً للتراجع.',
      },
      slices: {
        title: 'اشحن على شرائح',
        body: 'خطوات صغيرة قابلة للتراجع خلف مفتاح تشغيل. الترحيل الذي لم يلاحظه أحد هو الترحيل الناجح.',
      },
      team: {
        title: 'اترك الفريق أقوى',
        body: 'قرارات مكتوبة، وكود مُراجَع، وأشخاص يديرون النظام بكفاءة تامة من دوني.',
      },
    },
  },

  about: {
    whereTitle: 'أين عملت',
    beyondTitle: 'خارج نطاق العمل',
    roles: {
      terramira: 'مهندس برمجيات، أنظمة جغرافية',
      withthegrid: 'مهندس أول وقائد فريق',
      'sg-wireless': 'مهندس أول وقائد فريق',
      pycom: 'مهندس ← قائد فريق',
      iss: 'بيروت ← مسقط',
    },
    beyond: {
      mentoring: {
        title: 'الإرشاد',
        body: 'مراجع مشاريع في Udacity، ومرشد في Pluralsight — أربع سنوات في مراجعة أكواد الآخرين.',
      },
      writing: {
        title: 'الكتابة',
        body: 'عن التوسّع وقيادة الفرق والأجزاء المملّة من الموثوقية.',
      },
      languages: {
        title: 'اللغات',
        body: 'العربية، الإنجليزية، الهولندية، الفرنسية',
      },
      education: {
        title: 'الدراسة',
        body: 'ماجستير في تقنية النانو — غرونوبل · بكالوريوس هندسة — جامعة بيروت العربية',
      },
    },
  },

  hire: {
    titleLine1: 'لنبنِ شيئاً',
    titleLine2: 'متيناً',
    lede: 'أدوار قيادية، أو عمل تعاقدي، أو رأي ثانٍ في بنيتكم التقنية.',
    github: 'GitHub',
    linkedin: 'LinkedIn',
    cv: 'السيرة الذاتية (PDF)',
  },

  offers: {
    architecture_review: {
      eyebrow: 'الأكثر طلباً',
      title: 'مراجعة البنية التقنية',
      body: 'أسبوعان. أقرأ الكود، وأتحدّث مع مهندسيكم، وأعيد إليكم خطة مرتّبة بالأولويات تستطيعون تنفيذها من دوني.',
      terms: 'أجر ثابت · من 6 آلاف يورو',
    },
    contract_lead: {
      eyebrow: 'عمل ميداني',
      title: 'قيادة تعاقدية',
      body: 'من شهرين إلى ستة أشهر داخل فريقكم — البنية، والأجزاء الصعبة من الكود، وإرشاد الفريق ونحن نشحن.',
      terms: 'أجر يومي · بالتفاهم',
    },
    full_time: {
      eyebrow: 'التزام طويل',
      title: 'دور بدوام كامل',
      body: 'قيادة أو هندسة أولى في هولندا أو عن بُعد داخل أوروبا. أرسلوا الدور والفريق الذي تريدون أن أبنيه.',
      terms: 'غير متاح حاليًا',
    },
  },

  form: {
    title: 'أرسل طلبك',
    lede: 'لا شيء أكثر من هذا — بلا روابط مواعيد، ولا نماذج خلف نماذج.',
    engagementLegend: 'نوع العمل',
    engagement: {
      architecture_review: 'مراجعة بنية',
      contract_lead: 'قيادة تعاقدية',
      full_time: 'دور بدوام كامل',
      talk_workshop: 'محاضرة / ورشة',
    },
    name: 'الاسم',
    namePlaceholder: 'اسمك',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'you@company.com',
    company: 'الشركة',
    companyOptional: '— اختياري',
    companyPlaceholder: 'مكان عملك',
    problem: 'ما هي المشكلة؟',
    problemPlaceholder: 'ما الذي تبنونه، وما الذي يعترض طريقكم؟',
    when: 'متى',
    budget: 'الميزانية',
    budgetOptional: '— اختياري',
    timing: {
      immediately: 'فوراً',
      within_a_month: 'خلال شهر',
      within_a_quarter: 'خلال ثلاثة أشهر',
      exploring: 'مجرد استطلاع',
    },
    budgets: {
      prefer_to_discuss: 'أفضّل التفاهم',
      under_10k: 'أقل من 10 آلاف يورو',
      from_10k_to_25k: '10 – 25 ألف يورو',
      from_25k_to_75k: '25 – 75 ألف يورو',
      over_75k: 'أكثر من 75 ألف يورو',
    },
    submit: 'أرسِلها',
    sending: 'جارٍ الإرسال…',
    reassurance: 'سأردّ شخصياً خلال يومَي عمل. اتفاقية سرّية عند الطلب.',
    dismiss: 'إغلاق',
    turnstileUnavailable: 'تعذّر تحميل فحص التحقّق البشري. عطّل مانع الإعلانات، أو راسلني مباشرة.',
    validation: {
      name: 'الاسم مطلوب',
      email: 'مطلوب بريد إلكتروني صالح',
      problem: 'يرجى وصف المشكلة بتفصيل أوفى',
    },
    status: {
      successTitle: 'أُرسل الطلب',
      success: 'أُرسل الطلب. المرجع {{reference}} — سأردّ خلال يومَي عمل.',
      errorTitle: 'لم يُرسل',
      verification: 'لم يجتز فحص التحقّق البشري. يرجى المحاولة مجدداً.',
      rateLimited: 'طلبات كثيرة جداً. حاول مجدداً بعد بضع دقائق.',
      error: 'تعذّر إرسال الطلب. راسلني مباشرة على {{email}}.',
    },
  },

  next: {
    title: 'ما يحدث بعد ذلك',
    replyNote: 'أيندهوفن · يردّ خلال يومين',
    steps: {
      read: { title: 'أقرأه', body: 'شخصياً، خلال يومَي عمل.' },
      answer: {
        title: 'جواب صريح',
        body: 'نعم، أو لا، أو: «هذا شخص أفضل مني لهذا العمل».',
      },
      call: {
        title: 'مكالمة نصف ساعة',
        body: 'فقط إن كان هناك تناسب. بلا عرض تقديمي.',
      },
    },
  },
};
